import {Component, ComponentFactoryResolver, OnDestroy, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {AjaxDownloadService, AjaxDownloadQueueItem} from './ajax-download.service';
import {untilDestroyed} from 'ngx-take-until-destroy';
import {GenerationNotificationComponent} from './generation-notification/generation-notification.component';
import {take} from 'rxjs/operators';

@Component({
    selector: 'app-ajax-download-noty',
    templateUrl: 'ajax-download-noty.component.html',
    styleUrls: ['ajax-download-noty.component.scss'],
})

export class AjaxDownloadNotyComponent implements OnInit, OnDestroy {

    @ViewChild('container', { read: ViewContainerRef }) private container: ViewContainerRef;

    constructor(
        private service: AjaxDownloadService,
        private resolver: ComponentFactoryResolver,
    ) {
    }

    ngOnInit() {
        this.service.newItem$.pipe(
            untilDestroyed(this),
        ).subscribe((item: AjaxDownloadQueueItem) => {
            this.newNotification(item);
        });
    }

    ngOnDestroy(): void {
    }

    newNotification(queueItem: AjaxDownloadQueueItem) {
        const factory = this.resolver.resolveComponentFactory(GenerationNotificationComponent);
        const ref = this.container.createComponent(factory);

        ref.instance.queueItem$ = queueItem;

        ref.instance.wannaBeDestroyed.pipe(
            take(1)
        ).subscribe(() => {
            ref.destroy();
        });
    }
}
